const transformer = function (origin, defs) {
  return {
    render: 'ref',
    origin,
    value: origin,
    defs,
  }
}

export default transformer
